import type { ReactElement } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const TRENDING_ITEM_COUNT = 4;

export function TrendingCarouselPdSkeleton(): ReactElement {
    return (
        <div
            aria-hidden="true"
            className="mx-auto w-full max-w-[390px] space-y-4 overflow-hidden px-4 pb-4 pt-6"
            data-testid="trending-carousel-pd-skeleton">
            <Skeleton className="h-5 w-32" />
            <div className="flex gap-4 overflow-hidden">
                {Array.from({ length: TRENDING_ITEM_COUNT }, (_, index) => (
                    <Skeleton key={`trending-item-${index}`} className="size-20 shrink-0 rounded-full" />
                ))}
            </div>
        </div>
    );
}

export default TrendingCarouselPdSkeleton;
